<template>
<div id="exam_list" class="exam_list">
	<submenu :nav="0" @refresh="my_exam_list"></submenu>
	<div class="list_con" v-loading="uinfo_load">
		<div class="list" v-if="xueqiCon.length>0">
            <div class="exam_data" v-for="(item,i) in xueqiCon" :key="i">
				<font class="condition" :class="item.status!=3?'not':''">{{statusFn(item.status)}}</font>
                <div>
                    <p class="exam_title">{{item.title}}</p>
                    <p class="exam_time">考试时间：{{timeFn(item)}}</p>
                </div>
                <div style="display: flex;">
					<p v-if="temp.list.fraction" class="fraction">得分：{{item.score!==undefined?item.score:'-'}}</p>
					<p v-if="temp.list.remark && item.remark" @click="open_remark(item, 'remark')" class="joinBtn">考试须知</p>
					<p v-if="temp.list.result && item.status!=4" class="joinBtn" :class="item.test_count==0?'disable':''" @click.prevent="join_kaoshi2(item)">查看结果</p>
					<p v-if="temp.list.join_test" :class="tabBtnClas(item)" @click.prevent="open_remark(item, 'join_test')">{{tabCtrlText(item)}}</p>
                    <!-- <el-button type="primary">主要按钮</el-button>
                    <el-button type="primary">查看结果</el-button>
                    <el-button type="primary" @click="jinrukaoshi(item)">{{tabCtrlText(item)}}</el-button> -->
                </div>
            </div>
		</div>
        <div v-else>
            <div class="nodata">
                <img :src="nodataImg">
                <p>待更新</p>
            </div>
        </div>
	</div>
	<el-dialog
		title="考试须知"
		:visible.sync="open_remark_visible"
		width="80%">
		<span v-html="open_remark_content"></span>
		<span slot="footer" class="dialog-footer">
			<!-- <el-button @click="open_remark_visible = false">取 消</el-button> -->
			<el-button type="primary" v-if="open_remark_type == 'remark'" @click="open_remark_visible = false">确 定</el-button>
			<el-button type="primary" v-if="open_remark_type == 'join_test'" @click="jinrukaoshi(test_info)">进入考试</el-button>
		</span>
	</el-dialog>

	<!-- 摄像头确认对话框 -->
	<el-dialog
	  title="请确认"
	  :visible.sync="camera_open"
	  :before-close="camera_open_hidden"
	  width="30%">
		<span>请确认摄像头是否正常使用</span>
		<div v-loading="camera_load">
			<video ref="mediaElement" id="videoCamera" autoplay style="width:100%"></video>
			<!-- <canvas style="display:none;" id="canvasCamera"></canvas>
			<div v-if="imgSrc" class="img_bg_camera">
				<img :src="imgSrc" alt="" class="tx_img">
			</div> -->
			<div class="dialog-footer el-dialog__footer">
				<el-button @click="camera_open_hidden">否</el-button>
				<el-button type="primary" @click="join_kaoshi(jinrukaoshidata)">是</el-button>
			</div>
		</div>
	</el-dialog>

	<!-- 人脸验证 -->
	<el-dialog
		title="人脸验证"
		:visible.sync="flow_path"
		:before-close="handleClose"
		width="1100px">
		
		
		<div class="flow_path_f">
			<div v-if="tab_i==1">
				<div class="flow_path_h2">考试流程说明</div>
				<div class="flow_path">
        		    <div class="flow_path_thread">
        		        <div class="flow_num">1</div>
        		        <div class="flow_text">
        		            <div class="flow_hed">身份验证</div>
        		            <div class="flow_tit">点击“开始考试”后，系统会进入人脸识别身份验证</div>
        		        </div>
        		    </div>
        		    <div class="thread">
        		    </div>
        		    <div class="flow_path_thread">
        		        <div class="flow_num">2</div>
        		        <div class="flow_text">
        		            <div class="flow_hed">确认信息</div>
        		            <div class="flow_tit">确认个人信息是否正确，如不正确请及时上报</div>
        		        </div>
        		    </div>
        		    <div class="thread">
        		    </div>
        		    <div class="flow_path_thread">
        		        <div class="flow_num">3</div>
        		        <div class="flow_text">
        		            <div class="flow_hed">开始考试</div>
        		            <div class="flow_tit">完成身份验证后进入考试答题界面</div>
        		        </div>
        		    </div>
        		    <div class="thread">
        		    </div>
        		    <div class="flow_path_thread">
        		        <div class="flow_num">4</div>
        		        <div class="flow_text">
        		            <div class="flow_hed">完成考试</div>
        		            <div class="flow_tit">答题时间结束或完成所有试题后，点击交卷按钮完成考试</div>
        		        </div>
        		    </div>
        		</div>
				<div class="flow_path_h3" style="margin-top: 120px;">无法认证或者多次认证失败请联系教务老师 </div>
				<div class="flow_path_btn" style="margin-top: 80px;">
					<div class="flow_path_set" @click="describe_face_verify_request()">开始考试</div>
				</div>
			</div>
			<div v-if="tab_i==2">
				<div class="flow_path_h2">身份验证</div>
				<div class="flow_path_h3">请正面对摄像头，保持光线充足</div>
				<div class="con_round">
        		    <div class="round_white">
        		        <img style="width: 100%" :src="temporarily_url" alt="">
        		        <div class="identify_status" :style="face_bol?'':'background-color: #ff5959;'">
        		            {{identify_txt}}
        		        </div>
        		    </div>
        		</div>
				<div class="flow_path_btn" style="margin-top: 50px;">
					<div class="flow_path_set" :class="face_bol?'':'not_set'" @click="set_tab('add')">下一步</div>
				</div>
			</div>
			<div v-if="tab_i==3">
				<div class="flow_path_h2">确认信息</div>
				<div class="flow_path_h3">如果信息不正确，请及时告知考试管理员，避免影响个人考试成绩 </div>
				<div class="confirm">
					<div class="flow_path_head_sculpture">
						<img :src="temporarily_url" alt="" style="width: 100%;margin-top: 69%;transform: translateY(-50%);">
					</div>
					<div class="flow_path_data">
						<div class="flow_path_data_name">
							<span>学生姓名：</span>{{exam_name}}
						</div>
						<div class="flow_path_data_name">
							<span>身份证号：</span>{{exam_ic}}
						</div>
					</div>
				</div>
				<div class="flow_path_btn" style="margin-top: 50px;">
					<div class="flow_path_set" @click="open_text()">开始考试</div>
				</div>
			</div>
		</div>


	</el-dialog>
</div>
</template>

<script>
import * as rts from 'aliyun-rts-sdk';
import submenu from "./submenu";					//顶部
export default {
	name: 'exam_list'
	,components:{
		submenu
	}
	,data () {
		return {
			temp: this.temp.course_info.exam_list
			,qiNum:0
			,qiDang:0
			,qiCount:0
			,uinfo_load:false
			,xueqiCon:[]
			,flow_path:false

			,temporarily_url:''
			,exam_name:''
			,exam_ic:''
			,identify_txt:''
			,face_bol:false//是否通过
			,camera_open:false		// 摄像头检测弹窗
			,camera_load: true		// 摄像头检测弹窗加载
			,this_test_id:''//考试id
			,img_url:'' //人脸路径
			,user_id:''//学生id
			,certified:false//是否实名
			,tab_i:1

			,idcard: ''
			,nick_name: ''
			,open_remark_visible: false		// 考试须知是否显示
			,open_remark_content: ''		// 考试须知内容
			,open_remark_type: ''			// 考试须知弹窗类型
			,test_info: ''					// 考试须知的考试信息

			,returnHost: this.global.serverSrc		// 阿里云实人认证回调域名
		}
	}
	,mounted:function(){
		if(process.env.NODE_ENV == "development"){
			this.returnHost = window.location.origin
		}
        // return false
		var that=this
		
		let query=this.$route.query;
		this.$selfjs.getUserCallFn(this, function(res){
			that.idcard = res.idcard
			that.exam_name=res.nick_name					//学生姓名
			that.exam_ic = that.idcard				         	//学生身份证
			that.user_id = res.id						//学生id
			that.certified = res.certified				//是否实名
		})

		this.my_exam_list()			//获取考试列表

		if (query.tab_i) {
			that.tab_i = query.tab_i
			that.this_test_id = query.this_test_id
			// this.getKaoshiList()
			that.flow_path = true
			// 初始化url对象
        	var this_url = new URL(window.location.href);
        	// 解析response
        	var response = {}
			if (this_url.searchParams.get('response')) {
				response = JSON.parse(
        		    decodeURIComponent(this_url.searchParams.get('response'))
        		);
			}
			if (response.extInfo) {
				let data = {
					certifyId:response.extInfo.certifyId
				}
				this.$ajax.post(this.global.serverSrc + this.global.qianzui + "/aliyun/describe_face_verify",this.$qs.stringify(data))
				.then(res=>{
					// console.log(res);
					let resData=res.data.data;
					if(resData.Code=='200'){
						resData.ResultObject.MaterialInfo = JSON.parse(resData.ResultObject.MaterialInfo)
						// console.log(resData);
						if (resData.ResultObject.Passed=='T') {//通过
							// console.log(resData.ResultObject.MaterialInfo.facialPictureFront.pictureUrl);
							that.temporarily_url = resData.ResultObject.MaterialInfo.facialPictureFront.pictureUrl
							that.compare_face(resData.ResultObject.MaterialInfo.facialPictureFront.pictureUrl)
							// that.getBase64(null,resData.ResultObject.MaterialInfo.facialPictureFront.pictureUrl).then(result => {
							// 	that.upLoad(result,17)
							// });
						}else{//未通过
							this.identify_txt = '活体认证未通过'
							this.$message.error('认证未通过')
						}
					}else{
						this.identify_txt = '活体识别失败'
						this.$message.error(resData.Message)
					}
				}).catch(_ => {
					this.identify_txt = '活体识别失败'
					this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
			}	
		}
	}
	,methods:{
		// 跳转到学位英语的考试列表页
		// to_exam_en(){
		// 	this.$router.push({
		// 		path: '/web/exam_list_en',
		// 		name: 'exam_list_en',
		// 		query: {page: 'exam_list'},
		// 		params: ''
		// 	})	
		// },
		// 入口显示
		menu_show(arr){
			let val = false
			if(arr.indexOf(this.hideType) >= 0){
				val = true
			}
			return val
		},
		//获取考试列表
		my_exam_list(){
			this.uinfo_load = true
			let serverSrc = this.global.serverSrc
				,qianzui = this.global.qianzui
				,attach_url = serverSrc + qianzui + "/exam/my_exam_list"

			this.$ajax.get(attach_url,{
				params:{
					page:1,
					limit:9999
				}
			})
			.then((res)=>{
				this.uinfo_load = false
				let resData=res.data
					// console.log(resData);
				if(resData.code==0){
					this.xueqiCon=resData.data.data
				}else{
					this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
				}
			})
		},
		//学期中文字返回
		qiZh(i){
			return this.$selfjs.qiZh(i)
		},
		//学期是否已开学
		kaixue(i){
			if(this.qiThis>i){
				return '已完成学期'
			}else if(this.qiThis==i){
				return '当前学期'
			}else if(this.qiThis<i){
				return '未开学'
			}
		},
		//学期选择点击
		qiClick(event,num){
			var that=this
			var token=this.$cookies.get("token")
				,serverSrc=that.global.serverSrc
				,qianzui=that.global.qianzui
			this.$selfjs.qiSelect(this,{num:num}, function(option){
				that.qiNum = option.num
				that.loading = true
				
				//获取学期列表
				let attach_url = serverSrc + qianzui + "/member/user_result"
				that.$ajax.get(attach_url,{
					params:{
						term:num
					}
				})
				.then(function(res){
					let resData=res.data
						// console.log(resData);
					if(resData.code==0){
						that.xueqiCon=resData.data
					}else{
						that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
					}
				})
			})
		},
		//考试表格操作
		tabCtrlText(status){
			//1未考试（未到考试时间）
			//2待考试（时间内待考试）
			//3待考试（已过时间）
			//4已考试
			let stTxt='考试已结束'
			if(status.status==1){
				stTxt='未到考试时间'
				return stTxt;
			}
			if(status.status==2){
				stTxt='待考'
				return stTxt;
			}
			if(status.status==3&&status.test_count<status.number){
				// stTxt='已完成'
				stTxt='进入考试'
				return stTxt;
			}
			return stTxt;
		},
		//状态文字输出
		statusFn(row){
			// console.log(exam_status);
			let resCon
			if(row == 4){
				resCon='已结束'
			}else if(row == 3){
				resCon='进行中'
			}else if(row == 2){
				resCon='待考'
			}else if(row == 1){
				resCon='发布中'
			}
			return resCon;
		},
		//时间文字输出
		timeFn(row){
			let resCon="-",
				timeTxt = row.start_time,
				timeTxt2 = row.end_time
			if(timeTxt&&timeTxt != "-"){
				let daytime=timeTxt.split(" ")
					,day=daytime[0]
					,time=daytime[1]
					,dayCon=day.split("-")
				let daytime2=timeTxt2.split(" ")
					,day2=daytime2[0]
					,time2=daytime2[1]
					,dayCon2=day2.split("-")
				resCon=dayCon[0]+"年"+dayCon[1]+"月"+dayCon[2]+"日 "+time+" - "+dayCon2[0]+"年"+dayCon2[1]+"月"+dayCon2[2]+"日 "+time2
			}
			return resCon;
		},
		// 进入考试
		jinrukaoshi(scope){
			let that = this
			//考试状态等于3才能进入考试
			if(scope.status == 3){
				this.jinrukaoshidata=scope
				// 少于11位的证件号判断为港澳台，跳过人脸识别
				if(this.idcard.length < 11){
					//跳转到考试页
					this.$router.push({
						path: '/web/courseInfo/test/',
						name: 'test',
						query: {test_id: scope.test_id},
						params: ''
					})	
					return false
				}
				//1需要拍照，-1不需要拍照，0为未设置
				if((scope.is_photograph == 1 || scope.is_inspection == 1)){
					this.camera_open=true		//打开验证摄像头功能弹窗
					this.camera_load = true		// 摄像头检测弹窗加载
					setTimeout(function(){
						that.getCompetence()		// 调用权限（打开摄像头功能）
					},100)
				}else{
					this.join_kaoshi(this.jinrukaoshidata)
				}
			}
		},
		//跳转到考试页
		join_kaoshi(scope, index, rows) {
			// return false
			//考试状态等于3 且 提交次数 小于 限制次数
			if(scope.status == 3 && (scope.test_count < scope.number) ){
				this.this_test_id = scope.test_id
				//打开进入考试页开关
				let global_join_kaoshi = this.global.join_kaoshi
				global_join_kaoshi.switch = true
				// 判断是否需要拍摄照片，1：需要，-1：不需要，0为未设置
				if(scope.is_photograph == 1){
					global_join_kaoshi.is_photograph = true
					global_join_kaoshi.photo_num_min = scope.photo_num_min
					global_join_kaoshi.photo_num_max = scope.photo_num_max
					global_join_kaoshi.photograph_interval = scope.photograph_interval
				}else if(scope.is_photograph == -1){
					global_join_kaoshi.is_photograph = false
				}
				if(global_join_kaoshi.is_photograph && this.camera != 1){
					this.$message.error("未检测到摄像头")
					return false
				}
				// 判断是否需要巡考，1：需要，-1：不需要，0为未设置
				if(scope.is_inspection == 1){
					global_join_kaoshi.is_inspection = true
				}else if(scope.is_inspection == -1){
					global_join_kaoshi.is_inspection = false
				}
				if(global_join_kaoshi.is_inspection && this.camera != 1){
					this.$message.error("未检测到摄像头!")
					return false
				}

				// 移除本地流
				this.removeStream("videoCamera")
				if (scope.is_face_verification==2) {
					const loading = this.$loading({
						lock: true,
						text: 'Loading',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$ajax.get(this.global.serverSrc + this.global.qianzui + "/member/check_session_face_identification")
		    		.then(res=>{
						let resData = res.data
						if(resData.code==0){
							if (resData.data.result==1) {
								//跳转到考试页
								this.$router.push({
									path: '/web/courseInfo/test/',
									name: 'test',
									query: {test_id: scope.test_id,img_url:resData.data.compare_avatars},
									params: ''
								})	
							}else if (this.certified) {
								this.tab_i = 1
								this.flow_path = true
								// 把抓拍、巡考的数据存到缓存，防止跳转域名时清除
								localStorage.setItem('join_kaoshi', JSON.stringify(this.global.join_kaoshi))
							}else{
								this.$message.error("请先完成实名认证！")
							}
						}else{
						}
						loading.close()
		    		}).catch(_ => {
						this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
						loading.close()
					});
					
				}else{
					//跳转到考试页
					this.$router.push({
						path: '/web/courseInfo/test/',
						name: 'test',
						query: {test_id: scope.test_id},
						params: ''
					})	
				}
				
			}
		},
		//跳转到考试结果页
		join_kaoshi2(scope, index, rows) {
			if (scope.test_count==0) {
				return false
			}
			this.$router.push({
				path: '/web/courseInfo/jieguo/',
				name: 'jieguo',
				query: {log_id: scope.log_id, test_id: scope.test_id},
				params: ''
			})

		},
		//上一步/下一步
		set_tab(set){
			if (set=='add') {
                if (this.face_bol) {
                    this.tab_i++
                }
			}else{
				this.tab_i--
			}
		},
		// 关闭摄像头对话框
		camera_open_hidden(){
			this.camera_open = false
			// 移除本地流
			this.localStream = ''
			this.removeStream("videoCamera")
		},
		// 移除本地流
		removeStream(camera){
			if(this.localStream){
				let mediaElement = document.getElementById(camera);
				let stream = mediaElement.srcObject;
				if(!stream) return false
				let tracks = stream.getTracks();
				tracks.forEach(function(track) {
					track.stop();
				});
				mediaElement.srcObject = null;
			}
		},
		//发起考试认证
		describe_face_verify_request(){
			// 在调用实人认证服务端发起认证请求时需要传入该MetaInfo值
        	var MetaInfo = window.getMetaInfo();
			// console.log(window.getMetaInfo());
			let data = {
				certName:this.exam_name,
				certNo:this.exam_ic,
				metaInfo:MetaInfo,
				// this.global.serverSrc+
				// returnUrl:`http://test.xuexi.qsxueli.com:8981/web/#/web/exam_list?this_test_id=${this.this_test_id}&tab_i=2&page=exam_list`,
				returnUrl: this.returnHost +`/web/#/web/exam_list?this_test_id=${this.this_test_id}&tab_i=2&page=exam_list`,
				// returnUrl:'https://xuexi.qsxueli.com/web/#/web/name_attestation'
			}
			// console.log(data.returnUrl);
			// return false
			// 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
        	if (navigator.mediaDevices === undefined) {
				navigator.mediaDevices = {}
        	}
        	// 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
        	// 使用getUserMedia，因为它会覆盖现有的属性。
        	// 这里，如果缺少getUserMedia属性，就添加它。
        	if (navigator.mediaDevices.getUserMedia === undefined) {
				// console.log(6);
				navigator.mediaDevices.getUserMedia = function (constraints) {
					// console.log(7);
					// 首先获取现存的getUserMedia(如果存在)
					var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
					// 有些浏览器不支持，会返回错误信息
					// 保持接口一致
					if (!getUserMedia) {
						// console.log(8);
						return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
					}
					// 否则，使用Promise将调用包装到旧的navigator.getUserMedia
					return new Promise(function (resolve, reject) {
						getUserMedia.call(navigator, constraints, resolve, reject)
					})
				}
        	}
        	var constraints = { audio: false, video: { width: 100, height: 100, transform: 'scaleX(-1)' } }
        	// navigator.mediaDevices.getUserMedia(constraints).then((stream)=>{
				const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});

				this.$ajax.post(this.global.serverSrc + this.global.qianzui + "/aliyun/describe_face_verify_request",this.$qs.stringify(data))
		    	.then(res=>{
					let resData=res.data.data;
					if(resData.Code=='200'){
						window.location.href = resData.ResultObject.CertifyUrl
					}else{
						this.$message.error(resData.MessageText)
					}
					loading.close()
		    	}).catch(_ => {
					loading.close()
					this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				});
        	// }).catch((err) => {
			// 	console.log(err)
			// 	this.camera = 0
			// 	this.$message.error("无法检测到摄像头。如果已经插入摄像头,请允许浏览器使用摄像头的权限")
        	// })
		},
		//人脸比对
		compare_face(url){
			let that = this
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$ajax.get(this.global.serverSrc + this.global.qianzui + "/aliyun/compare_face",{},{
				imagesStream:url,
			})
		    .then(res=>{
				let resData = res.data
				if(resData.code==0){
                    if (resData.data.Data.Confidence>70) {
						that.getBase64(null,that.temporarily_url).then(result => {
							that.upLoad(result)
						});
                        that.face_bol = true
                        that.identify_txt = '识别成功'
                    }else{
                        that.identify_txt = '识别失败'
                        that.face_bol = false
                    }
				}else{
                    that.face_bol = false
                    that.identify_txt = '识别失败'
				}
				loading.close()
		    }).catch(_ => {
				this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				loading.close()
			});
		},
		// 转base64
    	getBase64(file,imgUrl) {
			if (file) {
				// 获取到文件对象
            	var file = file;
            	// 获取FileReader实例
            	var reader = new FileReader();
            	// 将文件加载进入
            	reader.readAsDataURL(file);
	
				const promise = new Promise((resolve, reject) => {
				  	// 异步操作
					reader.onload = function (e) { 
            		    // 转换完成输出该文件base64编码
						resolve(this.result);
            		}
				});
				return promise
			}else{
				let image = new Image();
      			// 解决跨域问题
      			image.setAttribute("crossOrigin", "anonymous");
      			let imageUrl = imgUrl;
      			image.src = imageUrl;
      			// image.onload为异步加载
      			// eslint-disable-next-line no-undef
				const promise = new Promise((resolve, reject) => {
				  	// 异步操作
					image.onload = function() {
      				  	var canvas = document.createElement("canvas");
      				  	canvas.width = image.width;
      				  	canvas.height = image.height;
      				  	var context = canvas.getContext("2d");
      				  	// eslint-disable-next-line no-undef
      				  	context.drawImage(image, 0, 0, image.width, image.height);
      				  	var quality = 1;
      				  	// 这里的dataurl就是base64类型
      				  	// 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
      				  	let dataurl = canvas.toDataURL("image/jpeg", quality);
      				  	// sBase64 = dataurl
						resolve(dataurl);
      				};
				});
				return promise
			}
			
		},
		//上传
		upLoad(base64){
			let that = this
			let file = that.base64toFile(base64)
			const loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			let flname = this.$selfjs.createOssFileName()
			let upload_path = `xuexi.qsxueli.com/uploadFile/question_bank/${that.user_id}/${flname}.${file.type.split("/")[1]}`;
			//验证通过，上传图片
			this.$ajax.post(this.global.serverSrc + this.global.qianzui +"/aliyun/upload_token",this.$qs.stringify({dir:'xuexi.qsxueli.com/uploadFile/question_bank/'+that.user_id}))
		    .then(res=>{
				let resData = res.data
				if(resData.code==0){
					let oss_data = new FormData()
					oss_data.append("key",upload_path);
 					oss_data.append("policy", resData.data.policy);
 					oss_data.append("OSSAccessKeyId", resData.data.accesskeyid);
 					oss_data.append("success_action_status", '200');
 					oss_data.append("signature", resData.data.signature);
 					oss_data.append("file", file);
					
					this.$ajax.post(this.global.oss_link,oss_data).then(res=>{
						// console.log(res);
						if (res.ok) {
							that.img_url = upload_path
							that.save_session_face_identification()
						}else{
							that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
								confirmButtonText: '确定',
							});
						}
					})
				}else{
					this.$message.error(resData.message)
				}
				loading.close()
		    }).catch(_ => {
				that.$alert(file.name+'上传出错！前联系教务老师或管理员', '信息提示', {
					confirmButtonText: '确定',
				});
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
				loading.close()
			});
		},
		//人脸对比成功上传图片之后请求接口
		save_session_face_identification(){
			let serverSrc = this.global.serverSrc
				,qianzui = this.global.qianzui
				,attach_url = serverSrc + qianzui + "/member/save_session_face_identification"

			this.$ajax.post(attach_url,this.$qs.stringify({compare_avatars:this.img_url}))
			.then((res)=>{
				let resData=res.data
					// console.log(resData);
				if(resData.code==0){

				}else{
					this.$message.error('保存人脸状态异常！');
				}
			})
		},
		//base64转文件
		base64toFile (dataurl, filename = 'file') {
		    let arr = dataurl.split(',')
		    let mime = arr[0].match(/:(.*?);/)[1]
		    let suffix = mime.split('/')[1]
		    let bstr = atob(arr[1])
		    let n = bstr.length
		    let u8arr = new Uint8Array(n)
		    while (n--) {
		        u8arr[n] = bstr.charCodeAt(n)
		    }
		    return new File([u8arr], `${filename}.${suffix}`, {
		        type: mime
		    })

		},
		//人脸之后跳转考试
		open_text(){
			// let url = `http://test.xuexi.qsxueli.com:8981/web/#/web/courseInfo/test?test_id=${this.this_test_id}&img_url=${this.img_url}`
			let url = this.returnHost +`/web/#/web/courseInfo/test?test_id=${this.this_test_id}&img_url=${this.img_url}`
			window.location.href = url
		},
		//人脸验证关闭
		handleClose(done){
			done()
			// let url = this.global.serverSrc+`/web/#/web/exam_list?page=exam_list`
			// console.log(url);
			// window.location.href = url
			// this.$store.dispatch("/web/exam_list", this.$route)
			// this.$router.push({ path: '/web/index/', })
			// this.$nextTick(()=>{
			// 	this.$router.push({
			// 		path: '/web/exam_list/',
			// 		name: 'exam_list',
			// 		query: {
			// 			page: 'exam_list'
			// 		},
			// 		params: '',
			// 	})
			// })
		},
		tabBtnClas(scope){
			let className=''
			if(scope.status!=3){
				className="disable"
			}
			if(scope.test_count>=scope.number){
				className="disable"
			}
			return 'joinBtn '+className;
		},
		open_remark(item, type){
			switch (type){
				case 'remark':
					this.open_remark_visible = true
					this.open_remark_content = item.remark
					break;
				case 'join_test':
					if(item.status == 3){
						if(item.remark){
							this.open_remark_visible = true
							this.open_remark_content = item.remark
						}else{
							this.jinrukaoshi(item)
						}
					}
					break;
			}
			this.open_remark_type = type
			this.test_info = item
		},
		// 刷新列表
		reload(){

		},
		// 调用权限（打开摄像头功能）
      	getCompetence () {

			let aliRts = rts.AliRTS.createClient()
			/**
			 * isSupport检测是否可用
			 * @param {Object} supportInfo 检测信息
			 * @param {boolean} supportInfo.isReceiveVideo 是否拉视频流
			 * @return {Promise}
			 */
			aliRts.isSupport({
				isReceiveVideo: false
			}).then(re=> {
				// 可用
				let mediaElement = this.$refs.mediaElement
				/**
				 * 获取本地流localStream
				 * @param {Object} config 配置
				 * @param {boolean} config.audio 是否使用音频设备
				 * @param {boolean} config.video 是否使用视频设备
				 * @param {boolean} config.screen 是否使用屏幕捕获
				 * @returns {Promise}
				 */
				rts.AliRTS.createStream({
					audio: true,
					video: true,
					screen: false,
				}).then((localStream) => {
					// 预览推流内容，mediaElement是媒体标签audio或video
					localStream.play(mediaElement);
					// console.log(localStream);
					this.localStream = localStream
					this.camera = 1
					setTimeout(()=>{
						this.camera_load = false
					},1000)
				}).catch((err) => {
					// 错误码说明文档：https://help.aliyun.com/document_detail/397571.html
					// console.log(err)
					let message = err.message
					if (err.errorCode==10002) {
						message = '找不到摄像头'
					}
					this.$alert(`创建本地流失败，错误码：${err.errorCode}。${message}`, {
						type: 'error',
						confirmButtonText: '确定'
					})
					this.camera_load = false
				})
			}).catch(err=> {
				// 错误码说明文档：https://help.aliyun.com/document_detail/397571.html
				this.$alert(`错误码：${err.errorCode}。${err.message}`, {
					type: 'error',
					confirmButtonText: '确定'
				})
				this.camera_load = false
			})
      	},
	}
	,watch:{
	}
	,computed:{
		//根据身份隐藏内容
		hideType(){
			return parseInt(this.$store.state.hideType)
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!-- scoped单页面有效属性 -->

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/course_info/exam_list.vue